import {Modal} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import TopBar from "../../components/Layout/TopBar";
import MyButton from "../../components/Layout/MyButton";
import { faEnvelope, faXmark } from '@fortawesome/free-solid-svg-icons';
import {ClipLoader} from "react-spinners";
import {useAlert} from "react-alert";
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {method} from "lodash/util";
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import moment from "moment";
import {Editor} from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import {convertToRaw, EditorState} from "draft-js";
import {logError} from "../../components/Utils/FormatData";
import SelectorTchatChannel from '../../components/AgGrid/SelectorTchatChannel';
import { CHANNEL_TYPE, PROFIL } from '../../constants/enum';
import { MessageContext } from '../../context/MessageContext';

const css = {
    modal: {
        height: '100%',
        width: '100%',
    },
    container: {
        height: '85%',
        width: '90%',
        backgroundColor: 'white',
        borderRadius: '5px',
        margin: 'auto'
    },
    fullRow: {
        height: '100%',
        width: '100%',
        alignItems: 'center'
    },
    row: {
        height: 'calc(100% - 110px)',
        flexDirection: 'column',
        justifyContent: 'normal'
    },
    rowValidation: {
        height: '60px',
        flexDirection: 'column',
        justifyContent: 'normal',
        alignItems: 'flex-end'
    },
    messengerContainer: {
        height: 'calc(100% - 50px)',
        backgroundColor: 'white',
        borderRadius: '5px',
        overflowY: 'hidden'
    },
    tchatItemsContainer: {
        height: '60%',
        borderRadius: '5px',
        paddingTop: '30px',
        overflowY: 'auto'
    },
    tchatTextArea: {
        height: '40%'
    },
    tchatItem: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    tchatItemContent: {
        display: 'flex',
        maxWidth: '80%',
        position: 'relative',
    },
    tchatOwner: {
        display: 'flex',
        color: 'white',
        fontSize: '24px',
        padding: '10px',
        margin: '10px',
        minWidth: '30px',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tchatContent: {
        fontSize: '16px',
        paddingTop: '10px'
    },
    tchatContentDescription: {
        fontSize: '18px',
        backgroundColor: '#e9e9e9',
        alignItems: 'center',
        padding: '20px',
        borderRadius: '16px',
        color: 'black',
        minWidth: '200px'
    },
    tchatContentDate: {
        fontSize: '16px',
        marginTop: '5px'
    },
    messengerSendBtnContainer: {
        display: 'flex',
        width: '99%',
        justifyContent: 'flex-end',
        marginRight: '10px'
    },
}

const ModalViewTchats = (props) => {
    const {openModal, setOpenModal, color, dossier, user, profil, setNeedReload} = props;
    const alert = useAlert();
    const [isLoading, setIsLoading] = useState(true);
    const [listInternalTchat, setListInternalTchat] = useState([]);
    const [listExternalTchat, setListExternalTchat] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState(profil.profil < 5 ? CHANNEL_TYPE.INTERNE : CHANNEL_TYPE.EXTERNE);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [tchat, setTchat] = useState({
        requestPass: dossier.id,
        recipients: [user.login],
        title: "Tchat dossier n° " + dossier.id
    });
    const { markMessagesAsRead } = useContext(MessageContext);
    let previousRecipient = null;

    //#region useEffect

    useEffect(() => {
        if (openModal) {
            apiGetTchats();
        }
    }, [openModal]);
    useEffect(() => {
        setIsLoading(false);
        const targetList = selectedChannel === CHANNEL_TYPE.INTERNE ? listInternalTchat : listExternalTchat;
        if (targetList.length > 0) {
            let objDiv = document.getElementById("tchatsContainer");
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }, [listInternalTchat, listExternalTchat, selectedChannel]);

    //#endregion

    //#region Functions

    const handleCloseModal = () => {
        if (setNeedReload) {
            setNeedReload(true);
        }
        setIsLoading(false);
        setOpenModal(false);
    };

     const handleChannelChange = (e) => {
        if (e === CHANNEL_TYPE.INTERNE) {
            if (profil.profil !== PROFIL.CLIENT && profil.profil !== PROFIL.NOUVEAU){
                setSelectedChannel(e);
            }
        } else if (e === CHANNEL_TYPE.EXTERNE) {
            setSelectedChannel(e);
        }
    };

    const tchatTemplate = (tchat) => {
        let rightPos = tchat.account.user_id === user.user_id;
        let date = moment(tchat.date_message);
        let isSameRecipient = previousRecipient === tchat.account.user_id;
        let authorName = tchat.account.prenom && tchat.account.nom ? tchat.account.prenom + " " + tchat.account.nom : tchat.account.email;
        let firstRow = previousRecipient === null;

        previousRecipient = tchat.account.user_id;

        return (<div style={{
            ...css.tchatItem,
            justifyContent: rightPos ? 'right' : 'left',
            marginTop: firstRow ? '0px' : isSameRecipient ? '0px' : '50px',
        }}>
            <div style={rightPos ? {
                ...css.tchatItemContent,
                flexDirection: "row-reverse",
            } : css.tchatItemContent}>
                {tchatOwner(tchat.account.email, tchat.account.profil.type, rightPos, isSameRecipient)}
                {!isSameRecipient && selectedChannel === CHANNEL_TYPE.INTERNE && <div style={{position: 'absolute', left: rightPos ? 'auto' : '70px', right: rightPos ? '70px' : 'auto', top: '-10px'}}>
                    {authorName}
                </div>}
                {!isSameRecipient && selectedChannel === CHANNEL_TYPE.EXTERNE && <div style={{position: 'absolute', left: rightPos ? 'auto' : '70px', right: rightPos ? '70px' : 'auto', top: '-10px'}}>
                    {tchat.account.profil.type}
                </div>}
                <div style={css.tchatContent}>
                    <div style={css.tchatContentDescription} dangerouslySetInnerHTML={{__html: tchat.message}}/>
                    <div style={{
                        ...css.tchatContentDate,
                        justifyContent: rightPos ? 'right' : 'left',
                    }}>{date.format("DD/MM/YYYY à HH:mm")}</div>
                </div>
            </div>
        </div>)
    }
    const tchatOwner = (ownerMail, ownerType, isMainRecipient, hidden) => {
        let picture = selectedChannel === CHANNEL_TYPE.INTERNE ? ownerMail : ownerType;
        return (<div style={
            {
                ...css.tchatOwner,
                backgroundColor: isMainRecipient ? '#e91e63' : '#0094ca',
                opacity: hidden ? "0" : "1"
            }}>{picture.charAt(0).toUpperCase()}</div>)
    }
    const isValidForm = () => {
        if (draftToHtml(convertToRaw(editorState.getCurrentContent())).replace(/<\/?[^>]+(>|$)/g, "").replace("&nbsp;", " ").trim() === "") {
            return false;
        }
        return true;
    }

    //#endregion

    //#region API
    const sendNotification = () => {
        axios({method: 'get', url: URL_API + '/messagerie/send-notif', params: {requestPassId: dossier.id, userAction: user.user_id}})
        .then(() => {
            alert.removeAll();
            alert.success("La notification a été envoyé avec succés");
        })
        .catch((err) => {
            logError(alert, err);
        });
    }

    const apiGetTchats = () => {
        let channelType = [CHANNEL_TYPE.EXTERNE];
        if (profil.profil !== PROFIL.CLIENT && profil.profil !== PROFIL.NOUVEAU) {
            channelType.push(CHANNEL_TYPE.INTERNE);
        }

        axios({
            method: 'POST', url: `${URL_API}/messagerie/messages-dossier`,
            data: {
                id: dossier.id,
                channelType: channelType,
                userAction: user.user_id
            }
        })
            .then((response) => {
                alert.removeAll();
                setListExternalTchat([]);
                setListInternalTchat([]);
                let externalTchats = [];
                let internalTchats = [];
                let requestPassTchats = response.data;

                if (requestPassTchats.length > 0) {
                    markMessagesAsRead(user);
                    let recipients = tchat.recipients;

                    // On met à jour la liste des destinataires
                    requestPassTchats.map(function (tchat) {
                        if (!recipients.includes(tchat.account.login)) {
                            recipients.push(tchat.account.login);
                        }

                        if (tchat.channel_type === CHANNEL_TYPE.EXTERNE) {
                            externalTchats.push(tchat);
                        }

                        if (tchat.channel_type === CHANNEL_TYPE.INTERNE) {
                            internalTchats.push(tchat);
                        }
                    });

                    setTchat({...tchat, recipients: recipients})
                    setListExternalTchat(externalTchats);
                    setListInternalTchat(internalTchats);
                }
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.tchat);
            });
    }
    const sendTchat = () => {
        if (isValidForm()) {
            axios({method: 'post', url: URL_API + '/messagerie/envoi-message', data: buildTchat()})
                .then(() => {
                    alert.removeAll();
                    alert.success("Le tchat a été envoyé avec succés");
                    apiGetTchats();

                    setIsLoading(false);
                    setTchat({requestPass: null, recipients: [], title: ""});
                    setEditorState(EditorState.createEmpty());
                })
                .catch((err) => {
                    logError(alert, err);
                });
        }
    };
    const buildTchat = () => {
        return {
            expediteur: user.user_id,
            destinataires: tchat.recipients,
            numDossier: tchat.requestPass,
            title: tchat.title,
            message: draftToHtml(convertToRaw(editorState.getCurrentContent())),
            channelType: selectedChannel
        }
    }

    //#endregion

    return (
        <Modal open={openModal} style={{display: 'flex'}} disableEscapeKeyDown={true}>
            <div className='modal' style={css.modal}>
                <div style={css.container}>
                    <TopBar title={`Tchat lié au dossier [N°${dossier.id}]`} className='topbar-contenu' color={selectedChannel === CHANNEL_TYPE.INTERNE ? '#0094ca' : '#a5c946'}
                            buttons={<div className='topbar-buttons'>
                                {profil.profil !== PROFIL.CLIENT && profil.profil !== PROFIL.NOUVEAU && selectedChannel !== CHANNEL_TYPE.INTERNE &&
                                    <MyButton style="buttonValidation" onClick={() => sendNotification()} label="Envoyer une notification" icon={faEnvelope} sx={{backgroundColor: selectedChannel === CHANNEL_TYPE.INTERNE ? '#33a9d5 !important' : '#839d3c !important'}}/>
                                }
                                <MyButton onClick={() => handleCloseModal()} label="Fermer" icon={faXmark} sx={{backgroundColor: selectedChannel === CHANNEL_TYPE.INTERNE ? '#33a9d5 !important' : '#839d3c !important'}}/>
                            </div>}

                            radioSelector={
                                (profil.profil !== PROFIL.CLIENT && profil.profil !== PROFIL.NOUVEAU) &&
                                    <>
                                        <SelectorTchatChannel leftValue='externe' rightValue='interne' onChange={(e) => handleChannelChange(e)} defaultValue={selectedChannel} />
                                    </>
                            }
                    />

                    {isLoading && <div className='row' style={css.fullRow}>
                        <ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
                    </div>}

                    <div style={css.messengerContainer}>
                        <div style={css.tchatItemsContainer} id="tchatsContainer" className="tchats-container">
                            {selectedChannel === CHANNEL_TYPE.EXTERNE &&
                                listExternalTchat.map(function (tchat, index) {
                                    return (tchatTemplate(tchat))
                                }
                            )}
                            {selectedChannel === CHANNEL_TYPE.INTERNE &&
                              listInternalTchat.map(function (tchat, index) {
                                    return (tchatTemplate(tchat))
                                }
                              )}
                        </div>
                        <div style={css.tchatTextArea}>
                            <div style={{
                                height: '67%',
                                margin: '10px',
                                overflow: "auto",
                            }}>
                                <Editor
                                    editorState={editorState}
                                    wrapperClassName="demo-wrapper"
                                    editorClassName="demo-editor"
                                    onEditorStateChange={setEditorState}
                                    toolbar={
                                        {
                                            image: {
                                                defaultSize: {
                                                    height: 'auto',
                                                    width: '250',
                                                },
                                            }
                                        }
                                    }
                                />
                            </div>
                            <div style={css.messengerSendBtnContainer}>
                                <MyButton onClick={sendTchat} style="buttonValidationNoMargin" label={'Envoyer'}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );

};

export default ModalViewTchats;
